import {
  DropDown
} from '@vodacomsa/ns-react-components';
import styled from 'styled-components';

export const FormikSelectField = styled(DropDown)`
 width: 100%;
  height: 60px;
  margin-bottom: 10px;
  & > :nth-child(1) {
    background-color: var(--color-white);
    border-color: var(--color-grey-200);
    width: 100%;
    height: 60px;
   
    & > :nth-child(4) {
     background-color: transparent !important;
    }
   
    & > :nth-child(5) {
      display: none;
    }
  };

    &.focus-visible,
    &:focus,
    &:focus-visible {
      outline: none !important;
      box-shadow: none !important;
      border-color: var(--color-grey-200) !important;
    }
  }

   .focus-visible {
    outline: none !important;
    box-shadow: none !important;
    border-color: var(--color-grey-200) !important;
  }

`;